// 获取 cookie
export const getCookie = (name: string) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()!.split(';')[0];
  return null; // 如果没有找到，返回 null
};

// 设置 cookie
export const setCookie = (name: string, value: string, days: number) => {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/';
};

// 删除 cookie
export const deleteCookie = (name: string) => {
  setCookie(name, '', -1); // 设置过期时间为过去的时间
};
